import { Machine } from 'xstate';

export default Machine({
  key: 'ticket',
  initial: 'loading',
  states: {
    loading: {
      on: {
        DATA: 'ticket',
        ERROR: 'error',
        SLIP: 'slip',
      },
    },
    ticket: {
      on: {
        PHOTO_SIZE_ERROR: 'photo_size_error',
        IES_SIZE_ERROR: 'ies_size_error',
        SPEC_SIZE_ERROR: 'spec_size_error',
        ATTACH_SIZE_ERROR: 'attach_size_error',
      },
    },
    slip: {},
    photo_size_error: {
      on: {
        CANCEL: 'ticket',
      },
    },
    ies_size_error: {
      on: {
        CANCEL: 'ticket',
      },
    },
    spec_size_error: {
      on: {
        CANCEL: 'ticket',
      },
    },
    attach_size_error: {
      on: {
        CANCEL: 'ticket',
      },
    },
    error: {
      on: {
        RETRY: 'loading',
        CANCEL: 'ticket',
      },
    },
  },
});
